import {WorkflowInstanceStepEditModel} from "./workflow-instance-step-edit.model";
import {WorkflowStep} from "../../../enums/WorkflowStep";
import {BatchModel} from "../../batch/batch.model";
import {WorkflowStepDnaExtractionModel} from "../workflow-step-dna-extraction.model";
import {WorkflowStepDnaExtractionSwabLysisModel} from "../workflow-step-dna-extraction-swab-lysis.model";

export class WorkflowInstanceStepDnaExtractionSwabLysisEditModel extends WorkflowInstanceStepEditModel {

  batches: BatchModel[];

  static initFromStep(step: WorkflowStepDnaExtractionSwabLysisModel): WorkflowInstanceStepEditModel {
    const ret = new WorkflowInstanceStepDnaExtractionSwabLysisEditModel();
    ret.workflowStep = WorkflowStep.DNA_EXTRACTION_SWAB_LYSIS;
    ret.workflowInstanceStepId = step.id;
    ret.batches = step.batches;
    return ret;
  }

}
